var _defs, _circle, _path, _line, _line2, _line3, _path2, _line4, _line5, _line6, _path3, _line7, _path4, _line8, _line9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.7 126.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill:none;stroke:#f7f8de;}.cls-1,.cls-2,.cls-3,.cls-5{stroke-miterlimit:10;}.cls-1{stroke-width:4px;}.cls-2,.cls-3,.cls-4{stroke-linecap:round;}.cls-2{stroke-width:5.75px;}.cls-3,.cls-4{stroke-width:3px;}.cls-4{stroke-linejoin:round;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 63.35,
    cy: 63.35,
    r: 61.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.38,21.49",
    transform: "translate(-0.99 -0.65)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.01,
    y1: 23.35,
    x2: 40.86,
    y2: 23.35
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.86,
    y1: 105.35,
    x2: 40.86,
    y2: 23.35
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.01,
    y1: 105.35,
    x2: 40.86,
    y2: 105.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.92,24c1.76,1.72,3.48,3.47,5.21,5.21a1.52,1.52,0,0,0,.4.32,1.63,1.63,0,0,0,.73.12l4.74,0",
    transform: "translate(-0.99 -0.65)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 56.79,
    y1: 101.01,
    x2: 63.01,
    y2: 101.01
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.01,
    y1: 23.35,
    x2: 85.16,
    y2: 23.35
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 85.16,
    y1: 105.35,
    x2: 85.16,
    y2: 23.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.08,24c-1.74,1.74-3.48,3.47-5.21,5.22a1.16,1.16,0,0,1-1.06.43H64",
    transform: "translate(-0.99 -0.65)"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 69.22,
    y1: 101.01,
    x2: 63.01,
    y2: 101.01
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.35,106",
    transform: "translate(-0.99 -0.65)"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.35,
    y1: 105.35,
    x2: 85.16,
    y2: 105.35
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.07,
    y1: 106.61,
    x2: 106.31,
    y2: 19.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNophone);
export default __webpack_public_path__ + "static/media/nophone.7fd2c36f320a7d9d4c6ebeebaf96b31b.svg";
export { ForwardRef as ReactComponent };